import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { activityModel } from '../core/_models'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { downloadFileSigned, editActivity, exportAcivity, deleteActivity } from '../core/_requests'
import { toast } from 'react-toastify'
import { useDateFormat } from '../../../hooks/useDateFormat'
import { useTimeZone } from '../../../hooks/useTimeZone'
import { EditActivityModal } from '../views/EditActivityModal'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { useThemeMode } from '../../../../_metronic/partials'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'

export const ActivityCard = ({
  activity,
  index,
  length,
  getActivity,
  investorId,
  roundId,
  investorName,
}: {
  activity: activityModel
  index: number
  length: number
  getActivity: () => void
  investorId: number
  roundId?: number
  investorName?: string
}) => {
  const { DateTime } = require('luxon')
  const { mode } = useThemeMode()
  const { formatMessage } = useIntl()
  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const [editActivityModal, setEditActivityModal] = useState(false)
  const [activityData, setActivityData] = useState<activityModel>()
  const { getDateValue } = useDateFormat()
  const { getTimeZoneValue } = useTimeZone()
  const { currentUser, companyId } = useAuth()

  const onSubmitActivity = async (activityId: number, investorUserId: any) => {
    try {
      if (activityId) {
        investorUserId = investorUserId.map((item: any) => {
          return item.investorUserId
        })
        const {
          data: { success, errors },
        } = await editActivity({ activityId, status: 'done', investorUserId })
        if (success) {
          getActivity()
          toast.success(formatMessage({ id: 'Acitivity successfully mark as done' }))
          setShowKebabMenu(!showKebabMenu)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CRMEditActivitySuccessful,
              action: 'normal',
              metadata: {
                investor_user_id: investorUserId,
                activity_id: activityId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
              },
            },
          })
        } else {
          setShowKebabMenu(!showKebabMenu)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CRMEditActivityFailed,
              action: 'normal',
              metadata: {
                investor_user_id: investorUserId,
                activity_id: activityId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  const onExportActivity = async (activityId: number) => {
    try {
      if (activityId) {
        const {
          data: { data: values, success, errors },
        } = await exportAcivity({ activityId })
        if (success) {
          toast.success(formatMessage({ id: 'downloading activity...' }))
          setShowKebabMenu(!showKebabMenu)
          const url = window.URL.createObjectURL(new Blob([values]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'activity.csv')
          document.body.appendChild(link)
          link.click()
          link.remove()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CRMActivityCsvExportSuccessful,
              action: 'normal',
              metadata: {
                activity_id: activityId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
              },
            },
          })
        } else {
          setShowKebabMenu(!showKebabMenu)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CRMActivityCsvExportFailed,
              action: 'normal',
              metadata: {
                activity_id: activityId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err: any) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CRMActivityCsvExportFailed,
          action: 'normal',
          metadata: {
            activity_id: activityId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            error: err,
          },
        },
      })
    }
  }

  const onDeleteActivity = async (activityId: number) => {
    try {
      if (activityId) {
        const {
          data: { data: success, errors },
        } = await deleteActivity(activityId)
        if (success) {
          getActivity()
          toast.success(formatMessage({ id: 'Activity deleted successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CRMDeleteActivitySuccessful,
              action: 'normal',
              metadata: {
                activity_id: activityId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CRMDeleteActivityFailed,
              action: 'normal',
              metadata: {
                activity_id: activityId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err: any) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CRMDeleteActivityFailed,
          action: 'normal',
          metadata: {
            activity_id: activityId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            error: err,
          },
        },
      })
    }
  }

  const onDownloadActivity = async (activityName: string) => {
    const {
      data: { data: signedUrl, success },
    } = await downloadFileSigned(activityName)
    if (success) {
      const a = document.createElement('a')
      a.href = signedUrl
      a.download = 'download'
      document.body.appendChild(a)
      a.click()
      a.remove()
      document.body.removeChild(a)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CRMSignedFileDownloadSuccessful,
          action: 'normal',
          metadata: {
            activity_name: activityName,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
          },
        },
      })
    }
  }

  function convertToOffsetTime(utcTime: any, offset: any) {
    const offsetMatch = offset?.match(/([+-]\d{2}:\d{2})/)
    let extractedOffset
    if (offsetMatch === null) {
      extractedOffset = '00:00'
    } else {
      extractedOffset = offsetMatch[1]
    }
    const utcDateTime = DateTime.fromISO(utcTime, { zone: 'utc' })
    const offsetHours = parseInt(extractedOffset.split(':')[0])
    const offsetMinutes = parseInt(extractedOffset.split(':')[1])
    const offsetDateTime = utcDateTime.plus({ hours: offsetHours, minutes: offsetMinutes })
    const formattedDateTime = offsetDateTime.toISO({ suppressMilliseconds: true })
    const finalDate = getDateValue(formattedDateTime)
    const time_final = getTimeZoneValue(utcTime, offset)
    const final_date_string = finalDate + ' ' + time_final
    return final_date_string
  }

  return (
    <>
      {(() => {
        switch (activity?.activityType) {
          case 'call':
            return (
              <div className=' w-100 d-md-flex justify-content-md-center d-flex justify-content-start '>
                <div className='d-flex align-items-center me-2 position-relative'>
                  <img
                    src={
                      mode === 'dark'
                        ? toAbsoluteUrl('/media/icons/investor/ic_dark_call.svg')
                        : toAbsoluteUrl('/media/icons/investor/ic_call.svg')
                    }
                    alt='call icon'
                    className='w-25px h-25px w-md-40px h-md-40px z-index-1'
                  />
                  <div
                    className={`timeline-line ${length - 1 === index && length !== 1 ? 'timeline-update-last' : ' '
                      } ${0 === index && length !== 1 ? 'timeline-update-first' : ' '} ${length === 1 && 'timeline-update-only-one'
                      }`}
                  ></div>
                </div>

                <div className='card  py-md-4 mb-4' onMouseLeave={() => setShowKebabMenu(false)}>
                  <div className='card-body p-0'>
                    <div className='d-flex justify-content-between border-bottom border-gray-300 px-5 pt-3 pt-md-0'>
                      <div className='overflow-auto d-flex flex-column gap-2'>
                        <p className='fs-6 fw-semibold m-0'>{activity?.title}</p>
                        <p className='fs-6'>{activity?.meetingNotes}</p>
                      </div>
                      <div>
                        <div
                          className={`kebab-pin-container d-flex justify-content-center align-items-center cursor-pointer ${investorId < 0 ? 'd-none' : ''
                            }`}
                          onClick={() => setShowKebabMenu(!showKebabMenu)}
                        >
                          <i className='bi-three-dots-vertical '></i>
                        </div>
                        {showKebabMenu && (
                          <div className='card w-200px h-180px shadow rounded kebab-menu-dropdown-container cursor-pointer z-index-1'>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                type='button'
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onSubmitActivity(activity.activityId, activity?.investorUsers)
                                }}
                                disabled={activity.status === 'done' ? true : false}
                              >
                                {formatMessage({ id: 'Mark as Done' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                disabled={activity.status === 'done' ? true : false}
                                onClick={() => {
                                  setEditActivityModal(true)
                                  setActivityData(activity)
                                }}
                              >
                                {formatMessage({ id: 'Edit Activity' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onExportActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Export to CSV' })}
                              </button>
                            </div>
                            <div className='px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onDeleteActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Delete Activity' })}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='px-5 mt-md-4 mt-1 mb-2 mb-md-0 d-flex justify-content-between align-items-center'>
                      <p className='fs-7 m-0'>
                        <span>
                          {convertToOffsetTime(
                            activity.startActivityTime?.toString(),
                            activity.timeZone
                          )
                            ? convertToOffsetTime(
                              activity.startActivityTime?.toString(),
                              activity.timeZone
                            )
                            : DateTime.fromISO(
                              activity.startActivityTime?.toString()
                            ).toLocaleString(DateTime.DATE_HUGE)}{' '}
                          ({activity.timeZone})
                        </span>
                      </p>

                      <DisplayImage
                        imgName={activity?.activityImg?.name}
                        height='30px'
                        width='30px'
                        alt='profile'
                        fit='contain'
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          case 'meeting':
            return (
              <div className=' w-100 d-md-flex justify-content-md-center d-flex justify-content-start '>
                <div className='d-flex align-items-center me-2 position-relative'>
                  <img
                    src={
                      mode === 'dark'
                        ? toAbsoluteUrl('/media/icons/investor/ic_dark_meeting.svg')
                        : toAbsoluteUrl('/media/icons/investor/ic_meeting.svg')
                    }
                    alt='meeting icon'
                    className='w-25px h-25px w-md-40px h-md-40px z-index-1'
                  />
                  <div
                    className={`timeline-line ${length - 1 === index && length !== 1 ? 'timeline-update-last' : ' '
                      } ${0 === index && length !== 1 ? 'timeline-update-first' : ' '} ${length === 1 && 'timeline-update-only-one'
                      }`}
                  ></div>
                </div>

                <div className='card  py-md-4 mb-4' onMouseLeave={() => setShowKebabMenu(false)}>
                  <div className='card-body p-0'>
                    <div className='d-flex justify-content-between border-bottom border-gray-300 px-5 pt-3 pt-md-0'>
                      <div className='overflow-auto d-flex flex-column gap-2'>
                        <p className='fs-6 fw-semibold m-0'>{activity?.title}</p>
                        <div className='d-flex align-items-center'>
                          <a className='text-primary fs-6' href={activity.meetingLink}>
                            {activity.meetingLink}
                          </a>
                          {activity.meetingLink && (
                            <span
                              className='input-group-btn border-left-0 text-primary'
                              style={{ borderColor: '#e4e6ef !important' }}
                              onClick={() => {
                                navigator.clipboard.writeText(`${activity?.meetingLink}`)
                                toast.success(formatMessage({ id: 'Copied Successfully' }))
                              }}
                            >
                              <i className='fa fa-copy  btn'></i>
                            </span>
                          )}
                        </div>
                        <p className='fs-6 m-0 text-muted'>{activity?.meetingNotes}</p>
                      </div>

                      <div>
                        <div
                          className={`kebab-pin-container d-flex justify-content-center align-items-center cursor-pointer ${investorId < 0 ? 'd-none' : ''
                            }`}
                          onClick={() => setShowKebabMenu(!showKebabMenu)}
                        >
                          <i className='bi-three-dots-vertical '></i>
                        </div>
                        {showKebabMenu && (
                          <div className='card w-200px h-180px shadow rounded kebab-menu-dropdown-container cursor-pointer z-index-1'>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                type='button'
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                disabled={activity.status === 'done' ? true : false}
                                onClick={() => {
                                  onSubmitActivity(activity.activityId, activity?.investorUsers)
                                }}
                              >
                                {formatMessage({ id: 'Mark as Done' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                disabled={activity.status === 'done' ? true : false}
                                onClick={() => {
                                  setEditActivityModal(true)
                                  setActivityData(activity)
                                }}
                              >
                                {formatMessage({ id: 'Edit Activity' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onExportActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Export to CSV' })}
                              </button>
                            </div>
                            <div className='px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onDeleteActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Delete Activity' })}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='px-5 mt-md-4 mt-1 mb-2 mb-md-0 d-flex justify-content-between align-items-center'>
                      <p className='fs-7 m-0'>
                        {/* <span>Friday, 15 Jan 2024</span> <span>3:30 - 4:00pm</span> */}
                        <span>
                          {convertToOffsetTime(
                            activity.startActivityTime?.toString(),
                            activity.timeZone
                          )
                            ? convertToOffsetTime(
                              activity.startActivityTime?.toString(),
                              activity.timeZone
                            )
                            : DateTime.fromISO(
                              activity.startActivityTime?.toString()
                            ).toLocaleString(DateTime.DATE_HUGE)}{' '}
                          ({activity.timeZone})
                        </span>
                      </p>

                      <DisplayImage
                        imgName={activity?.activityImg?.name}
                        height='30px'
                        width='30px'
                        alt='profile'
                        fit='contain'
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          case 'tasks':
            return (
              <div className=' w-100 d-md-flex justify-content-md-center d-flex justify-content-start '>
                <div className='d-flex align-items-center me-2 position-relative'>
                  <img
                    src={
                      mode === 'dark'
                        ? toAbsoluteUrl('/media/icons/investor/ic_dark_tasks.svg')
                        : toAbsoluteUrl('/media/icons/investor/ic_tasks.svg')
                    }
                    alt='tasks icon'
                    className='w-25px h-25px w-md-40px h-md-40px z-index-1'
                  />
                  <div
                    className={`timeline-line ${length - 1 === index && length !== 1 ? 'timeline-update-last' : ' '
                      } ${0 === index && length !== 1 ? 'timeline-update-first' : ' '} ${length === 1 && 'timeline-update-only-one'
                      }`}
                  ></div>
                </div>

                <div className='card  py-md-4 mb-4' onMouseLeave={() => setShowKebabMenu(false)}>
                  <div className='card-body p-0'>
                    <div className='d-flex justify-content-between border-bottom border-gray-300 px-5 pt-3 pt-md-0'>
                      <div className='overflow-auto d-flex flex-column gap-2'>
                        <p className='fs-6 fw-semibold m-0'>{activity?.title}</p>
                        <p className='fs-6 '>
                          {activity?.meetingNotes ? activity?.meetingNotes : '-'}
                        </p>
                      </div>

                      <div>
                        <div
                          className={`kebab-pin-container d-flex justify-content-center align-items-center cursor-pointer ${investorId < 0 ? 'd-none' : ''
                            }`}
                          onClick={() => setShowKebabMenu(!showKebabMenu)}
                        >
                          <i className='bi-three-dots-vertical '></i>
                        </div>
                        {showKebabMenu && (
                          <div className='card w-200px h-180px shadow rounded kebab-menu-dropdown-container cursor-pointer z-index-1'>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                type='button'
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                disabled={activity.status === 'done' ? true : false}
                                onClick={() => {
                                  onSubmitActivity(activity.activityId, activity?.investorUsers)
                                }}
                              >
                                {formatMessage({ id: 'Mark as Done' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                disabled={activity.status === 'done' ? true : false}
                                onClick={() => {
                                  setEditActivityModal(true)
                                  setActivityData(activity)
                                }}
                              >
                                {formatMessage({ id: 'Edit Activity' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onExportActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Export to CSV' })}
                              </button>
                            </div>
                            <div className='px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onDeleteActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Delete Activity' })}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='px-5 mt-md-4 mt-1 mb-2 mb-md-0 d-flex justify-content-between align-items-center'>
                      <p className='fs-7 m-0'>
                        <span>
                          {convertToOffsetTime(
                            activity.startActivityTime?.toString(),
                            activity.timeZone
                          )
                            ? convertToOffsetTime(
                              activity.startActivityTime?.toString(),
                              activity.timeZone
                            )
                            : DateTime.fromISO(
                              activity.startActivityTime?.toString()
                            ).toLocaleString(DateTime.DATE_HUGE)}{' '}
                          ({activity.timeZone})
                        </span>
                      </p>

                      <DisplayImage
                        imgName={activity?.activityImg?.name}
                        height='30px'
                        width='30px'
                        alt='profile'
                        fit='contain'
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          case 'email':
            return (
              <div className=' w-100 d-md-flex justify-content-md-center d-flex justify-content-start '>
                <div className='d-flex align-items-center me-2 position-relative'>
                  <img
                    src={
                      mode === 'dark'
                        ? toAbsoluteUrl('/media/icons/investor/ic_dark_mail.svg')
                        : toAbsoluteUrl('/media/icons/investor/ic_mail.svg')
                    }
                    alt='email icon'
                    className='w-25px h-25px w-md-40px h-md-40px z-index-1'
                  />
                  <div
                    className={`timeline-line ${length - 1 === index && length !== 1 ? 'timeline-update-last' : ' '
                      } ${0 === index && length !== 1 ? 'timeline-update-first' : ' '} ${length === 1 && 'timeline-update-only-one'
                      }`}
                  ></div>
                </div>

                <div className='card  py-md-4 mb-4' onMouseLeave={() => setShowKebabMenu(false)}>
                  <div className='card-body p-0'>
                    <div className='d-flex justify-content-between border-bottom border-gray-300 px-5 pt-3 pt-md-0'>
                      <div className='overflow-auto d-flex flex-column gap-2'>
                        <p className='fs-6 fw-semibold m-0'>{activity?.title}</p>
                        <p className='fs-6 '>
                          {activity?.meetingNotes ? activity?.meetingNotes : '-'}
                        </p>
                      </div>
                      <div>
                        <div
                          className={`kebab-pin-container d-flex justify-content-center align-items-center cursor-pointer ${investorId < 0 ? 'd-none' : ''
                            }`}
                          onClick={() => setShowKebabMenu(!showKebabMenu)}
                        >
                          <i className='bi-three-dots-vertical '></i>
                        </div>
                        {showKebabMenu && (
                          <div className='card w-200px h-180px shadow rounded kebab-menu-dropdown-container cursor-pointer z-index-1'>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                type='button'
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onSubmitActivity(activity.activityId, activity?.investorUsers)
                                }}
                                disabled={activity.status === 'done' ? true : false}
                              >
                                {formatMessage({ id: 'Mark as Done' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                disabled={activity.status === 'done' ? true : false}
                                onClick={() => {
                                  setEditActivityModal(true)
                                  setActivityData(activity)
                                }}
                              >
                                {formatMessage({ id: 'Edit Activity' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onExportActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Export to CSV' })}
                              </button>
                            </div>
                            <div className='px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onDeleteActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Delete Activity' })}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='px-5 mt-md-4 mt-1 mb-2 mb-md-0 d-flex justify-content-between align-items-center'>
                      <p className='fs-7 m-0'>
                        <span>
                          {convertToOffsetTime(
                            activity.startActivityTime?.toString(),
                            activity.timeZone
                          )
                            ? convertToOffsetTime(
                              activity.startActivityTime?.toString(),
                              activity.timeZone
                            )
                            : DateTime.fromISO(
                              activity.startActivityTime?.toString()
                            ).toLocaleString(DateTime.DATE_HUGE)}{' '}
                          ({activity.timeZone})
                        </span>
                      </p>
                      <DisplayImage
                        imgName={activity?.activityImg?.name}
                        height='30px'
                        width='30px'
                        alt='profile'
                        fit='contain'
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          case 'notes':
            return (
              <div className=' w-100 d-md-flex justify-content-md-center d-flex justify-content-start '>
                <div className='d-flex align-items-center me-2 position-relative'>
                  <img
                    src={
                      mode === 'dark'
                        ? toAbsoluteUrl('/media/icons/investor/ic_dark_notes.svg')
                        : toAbsoluteUrl('/media/icons/investor/ic_notes.svg')
                    }
                    alt='notes icon'
                    className='w-25px h-25px w-md-40px h-md-40px z-index-1'
                  />
                  <div
                    className={`timeline-line ${length - 1 === index && length !== 1 ? 'timeline-update-last' : ' '
                      } ${0 === index && length !== 1 ? 'timeline-update-first' : ' '} ${length === 1 && 'timeline-update-only-one'
                      }`}
                  ></div>
                </div>

                <div className='card  py-md-4 mb-4' onMouseLeave={() => setShowKebabMenu(false)}>
                  <div className='card-body p-0'>
                    <div className='d-flex justify-content-between border-bottom border-gray-300 px-5 pt-3 pt-md-0'>
                      <div className='overflow-auto d-flex flex-column gap-2'>
                        <p className='fs-6 fw-semibold m-0'>{activity?.title}</p>
                        <p className='text-primary fs-6 '>
                          {activity?.meetingNotes ? activity?.meetingNotes : '-'}
                        </p>
                      </div>
                      <div>
                        <div
                          className={`kebab-pin-container d-flex justify-content-center align-items-center cursor-pointer ${investorId < 0 ? 'd-none' : ''
                            }`}
                          onClick={() => setShowKebabMenu(!showKebabMenu)}
                        >
                          <i className='bi-three-dots-vertical '></i>
                        </div>
                        {showKebabMenu && (
                          <div className='card w-200px h-180px shadow rounded kebab-menu-dropdown-container cursor-pointer z-index-1'>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                type='button'
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onSubmitActivity(activity.activityId, activity?.investorUsers)
                                }}
                                disabled={activity.status === 'done' ? true : false}
                              >
                                {formatMessage({ id: 'Mark as Done' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                disabled={activity.status === 'done' ? true : false}
                                onClick={() => {
                                  setEditActivityModal(true)
                                  setActivityData(activity)
                                }}
                              >
                                {formatMessage({ id: 'Edit Activity' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onExportActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Export to CSV' })}
                              </button>
                            </div>
                            <div className='px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onDeleteActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Delete Activity' })}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='px-5 mt-md-4 mt-1 mb-2 mb-md-0 d-flex justify-content-between align-items-center'>
                      <p className='fs-7 m-0'>
                        <span>
                          {getDateValue(activity.startActivityTime?.toString())
                            ? getDateValue(activity.startActivityTime?.toString())
                            : DateTime.fromISO(
                              activity.startActivityTime?.toString()
                            ).toLocaleString(DateTime.DATE_HUGE)}{' '}
                          {getTimeZoneValue(activity.startActivityTime?.toString())}
                        </span>
                      </p>

                      <DisplayImage
                        imgName={activity?.activityImg?.name}
                        height='30px'
                        width='30px'
                        alt='profile'
                        fit='contain'
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          case 'documents':
            return (
              <div className=' w-100 d-md-flex justify-content-md-center d-flex justify-content-start '>
                <div className='d-flex align-items-center me-2 position-relative'>
                  <img
                    src={
                      mode === 'dark'
                        ? toAbsoluteUrl('/media/icons/investor/ic_dark_documents.svg')
                        : toAbsoluteUrl('/media/icons/investor/ic_documents.svg')
                    }
                    alt='documents icon'
                    className='w-25px h-25px w-md-40px h-md-40px z-index-1'
                  />
                  <div
                    className={`timeline-line ${length - 1 === index && length !== 1 ? 'timeline-update-last' : ' '
                      } ${0 === index && length !== 1 ? 'timeline-update-first' : ' '} ${length === 1 && 'timeline-update-only-one'
                      }`}
                  ></div>
                </div>

                <div className='card  py-md-4 mb-4' onMouseLeave={() => setShowKebabMenu(false)}>
                  <div className='card-body p-0'>
                    <div className='d-flex justify-content-between border-bottom border-gray-300 px-5 pt-3 pt-md-0'>
                      <div className='overflow-auto d-flex flex-column gap-2'>
                        <p className='fs-6 fw-semibold m-0'>{activity?.title}</p>
                        <p className='fs-6'>
                          {activity.meetingNotes ? activity.meetingNotes : '-'}
                        </p>

                        <div className='d-flex flex-wrap pb-5'>
                          {activity?.documentImg && (
                            <div
                              className='d-flex flex-aligns-center pe-10 pe-lg-20'
                              key={activity?.documentImg.fileId}
                            >
                              {activity?.documentImg.name.split('.').pop() === 'pdf' ? (
                                <>
                                  <img
                                    alt=''
                                    className='w-30px me-3'
                                    src={toAbsoluteUrl(`/media/icons/file_extensions/${activity?.documentImg.name.split('.').pop()}.svg`)}
                                  />

                                  <div className='ms-1'>
                                    <p
                                      className='fs-6 text-hover-primary cursor-pointer'
                                      onClick={() => onDownloadActivity(activity?.documentImg.name)}
                                    >
                                      {activity?.documentImg.name}
                                    </p>
                                  </div>
                                </>
                              ) : activity?.documentImg.name.split('.').pop() === 'png' ||
                                activity?.documentImg.name.split('.').pop() === 'jpg' ? (
                                <>
                                  <img
                                    alt=''
                                    className='w-30px me-3'
                                    src={toAbsoluteUrl('/media/svg/files/blank-image.svg')}
                                  />

                                  <div className='ms-1'>
                                    <p className='fs-6 text-hover-primary'>
                                      {activity?.documentImg.name}
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <div className='ms-1'>
                                  <p className='fs-6 text-hover-primary'>
                                    {activity?.documentImg.name}
                                  </p>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div>
                        <div
                          className={`kebab-pin-container d-flex justify-content-center align-items-center cursor-pointer ${investorId < 0 ? 'd-none' : ''
                            }`}
                          onClick={() => setShowKebabMenu(!showKebabMenu)}
                        >
                          <i className='bi-three-dots-vertical '></i>
                        </div>
                        {showKebabMenu && (
                          <div className='card w-200px h-180px shadow rounded kebab-menu-dropdown-container cursor-pointer z-index-1'>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                type='button'
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onSubmitActivity(activity.activityId, activity?.investorUsers)
                                }}
                                disabled={activity.status === 'done' ? true : false}
                              >
                                {formatMessage({ id: 'Mark as Done' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                disabled={activity.status === 'done' ? true : false}
                                onClick={() => {
                                  setEditActivityModal(true)
                                  setActivityData(activity)
                                }}
                              >
                                {formatMessage({ id: 'Edit Activity' })}
                              </button>
                            </div>
                            <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onExportActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Export to CSV' })}
                              </button>
                            </div>
                            <div className='px-4 py-3 dropdown-items'>
                              <button
                                className='m-0 border-0 bg-transparent dropdown_dark_text'
                                onClick={() => {
                                  onDeleteActivity(activity.activityId)
                                }}
                              >
                                {formatMessage({ id: 'Delete Activity' })}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='px-5 mt-md-4 mt-1 mb-2 mb-md-0 d-flex justify-content-between align-items-center'>
                      <p className='fs-7 m-0'>
                        {/* <span>Friday, 15 Jan 2024</span> <span>3:30 - 4:00pm</span> */}
                        <span>
                          {getDateValue(activity.startActivityTime?.toString())
                            ? getDateValue(activity.startActivityTime?.toString())
                            : DateTime.fromISO(
                              activity.startActivityTime?.toString()
                            ).toLocaleString(DateTime.DATE_HUGE)}{' '}
                          {getTimeZoneValue(activity.startActivityTime?.toString())}
                        </span>
                      </p>

                      <DisplayImage
                        imgName={activity?.activityImg?.name}
                        height='30px'
                        width='30px'
                        alt='profile'
                        fit='contain'
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
        }
      })()}
      <EditActivityModal
        modalShow={editActivityModal}
        setModalShow={setEditActivityModal}
        activityData={activityData}
        investorId={investorId}
        getActivity={getActivity}
        roundId={roundId}
        investorName={investorName!}
      />
    </>
  )
}
